import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MetaTags from '../components/MetaTags';
import { getBreadcrumbSchema } from '../utils/schemaGenerator';
import { useTheme } from '../context/ThemeContext';

const NoScamPolicyPage = () => {
  const { theme } = useTheme();
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'No Scam Policy', url: '/no-scam' }
  ]);

  return (
    <>
      <MetaTags
        title="No Scam Policy & Anti-Fraud Protection | BookMyAudition"
        description="BookMyAudition maintains zero tolerance for fake audition calls, scam agents, and fraudulent casting listings. Protect your acting career."
        keywords="no scam policy, fake auditions warning, genuine audition calls, fake casting directors India, anti-fraud audition policy"
        canonical="https://web.bookmyaudition.com/no-scam"
        schema={breadcrumbSchema}
      />
      <div className="scam-policy-page" style={{ minHeight: '70vh', padding: '60px 0', backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc', color: theme === 'dark' ? '#f8fafc' : '#111' }}>
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4">No Scam Policy</h1>
              <p className="mb-5">Zero tolerance for fraudulent activities and fake casting calls.</p>
              <div className="coming-soon-box p-5 rounded-4 shadow-sm" style={{ backgroundColor: theme === 'dark' ? '#111116' : '#fff', border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}` }}>
                <div className="d-inline-block mb-3 px-3 py-1 rounded-pill" style={{ backgroundColor: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', fontSize: '0.85rem', fontWeight: '600' }}>PROTECTION</div>
                <h3>Policy Documentation</h3>
                <p className="text-muted">Our legal team is finalizing the detailed scam prevention protocols. Be alert, be safe!</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
export default NoScamPolicyPage;